export default __webpack_public_path__ + "static/shinez-f5c912fd01f641141bb18744b63417c4.svg";